/**
 * Airtuerk / GTS uçuş bagaj etiketi (liste ve özet).
 */
export const BASIC_PERSONAL_ITEM_LABEL =
  '1 parça x 4 kg koltuk altına sığabilen çanta (40x30x15cm)';

export function isPersonalItemFeature(text) {
  const t = String(text || '');
  return t === BASIC_PERSONAL_ITEM_LABEL || t.includes('koltuk altına sığabilen');
}

export function isNoCheckedBaggageFeature(text) {
  return /kayıtlı bagaj dahil değil/i.test(String(text || ''));
}

export function orderFareFeatures(features, hasNoCheckedBaggage) {
  const list = [...(features || [])];
  if (!hasNoCheckedBaggage) return list;

  const personal = list.filter(isPersonalItemFeature);
  const noChecked = list.filter(isNoCheckedBaggageFeature);
  const rest = list.filter((f) => !isPersonalItemFeature(f) && !isNoCheckedBaggageFeature(f));

  const ordered = [...personal, ...noChecked, ...rest];
  if (noChecked.length === 0) {
    const insertAt = personal.length > 0 ? personal.length : 0;
    ordered.splice(insertAt, 0, 'Kayıtlı bagaj dahil değil');
  }
  return ordered;
}

export function formatFlightBaggageLabel(source) {
  if (!source) return '';
  if (source.baggage_label) return source.baggage_label;

  const baggage = Number(source.baggage ?? 0);
  const hand = Number(source.handLuggage ?? 0);
  const piece = Number(source.baggagePiece ?? 0);

  if (baggage > 0 && hand > 0) {
    return `${baggage} kg bagaj + ${hand} kg kabin`;
  }
  if (baggage > 0) {
    return piece > 1 ? `${baggage} kg bagaj (${piece} parça)` : `${baggage} kg bagaj`;
  }
  if (hand > 0) {
    return 'Sadece kabin bagajı';
  }
  return '';
}

export function baggageBadgesForOffer(offer, flight) {
  const label = formatFlightBaggageLabel(offer) || formatFlightBaggageLabel(flight);
  if (label) return [{ key: 'label', label }];

  const bags = flight?.baggages || offer?.baggages || [];
  return bags.map((bag, idx) => ({
    key: `bag-${idx}`,
    label: `${bag.Weight || bag.weight || ''}${bag.Unit || bag.unit || 'KG'}`,
  }));
}
